<template>
    <div class="event-info">
        <div style="display: flex;flex-direction: column;justify-content: space-between;width: 60%;">
            <div style="font-size: 1rem;color: #fff;">{{ item.name }}</div>
            <div style="font-size: 0.7rem;color: #fff;">{{ item.handler }}</div>
        </div>
        <div style="display: flex;flex-direction: column;justify-content: space-between;width: 40%;text-align: right;">
            <div style="font-size: 1rem;color: #fff;">{{ item.date }}</div>
            <div style="font-size: 0.7rem;color: #fff;">{{ item.source }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EventInfo',
    props: ['item']

}
</script>

<style lang="less" scoped>
.event-info {
    width: 100%;
    height: 4rem;
    display: flex;
    margin-bottom: 5px;
    padding: 5px;
    cursor: pointer;
    background-color: #22202034;
    border-radius: 5px;
}
</style>